import React from "react";
// reactstrap components
import { CardContacto, ItemTelefono, ItemEmail, Icon } from "./styles";
// import Chile from "../Icons/Chile";
// import Usa from "../Icons/Usa";
import WhatsApp from "../Icons/WhatsApp";
import Mail from "../Icons/Mail";
// import Phone from "../Icons/Phone";
import Formulario from "./Formulario.js";
import { Card, CardTitle, Container, Row, Col } from "reactstrap";


function SectionContactUs(props) {
  return (
    <>
      <div className="section section-contactus cd-section" id="contact-us">
        <div
          className="contactus-1 section-image"
          style={{
            backgroundImage:
              "url(" + require("assets/images/sections/contacto.jpg") + ")",
          }}
        >
          <Container>
        <Row>
          <Col className="ml-auto mr-auto" md="10">
            <Card className="card-contact no-transition">
              <CardTitle className="text-center" tag="h3">
                Contáctanos
              </CardTitle>
              <Row>
                <Col className="ml-auto" md="5">
                  <h4 className="info-title pl-3 pl-md-0">Información de Ventas</h4>
                  <CardContacto paddingTop="5px">
                    {/* <Chile size="25" /> */}
                    
                    <ItemTelefono>
                      <Icon>
                        <WhatsApp size="25" color="#1EBEA5" />

                      </Icon>
                      <a className="pl-2" href="https://api.whatsapp.com/send?phone=+56994361109">
                        +56 9 9436 1109
                      </a>
                    </ItemTelefono>
                    <ItemEmail>
                      <Icon>
                        <Mail size="25" color="#1EBEA5" />
                      </Icon>
                      <a className="pl-2 vertical-align-center" href="mailto:contacto@reservalosmuermos.cl ">
                        contacto@reservalosmuermos.cl 
                      </a>
                    </ItemEmail>  
                  </CardContacto>
                  <hr />
                </Col>
                <Col className="mr-auto" md="5">
                  <Formulario/>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
        </div>
      </div>
    </>
  );
}

export default SectionContactUs;
